import { useRemoteData } from "@sinch/mfe-helper-react";
import z from "zod";
import { getMessageMediaApiUrl } from "../../../config/config";

const INTEGRATIONS = ["bigcommerce", "shopify"] as const;
export type Integrations = (typeof INTEGRATIONS)[number];

const connectionStateZod = z.object({
  store_id: z.string(),
  state: z.union([z.literal("CONNECTED"), z.literal("COMPLETED")]),
});
export type IntegrationConnectionState = z.infer<typeof connectionStateZod>;

export const useValidateConnectionState = (
  integration: Integrations,
  isEnabled: boolean
) =>
  useRemoteData(
    `${getMessageMediaApiUrl()}/v1/bff/integrations/platforms/${integration}/connection`,
    {
      useToken: true,
      enabled: isEnabled && !!integration,
      parse: (data) => {
        const parsed = connectionStateZod.safeParse(data);
        if (parsed.success) return parsed.data;
        const errorMessage = `Invalid response from /integrations/platforms/${integration}/connection`;
        console.error(errorMessage, parsed.error);
        return data as IntegrationConnectionState;
      },
    }
  ).getState();
